import { ModelBase } from 'store/model-base';

export class CmsBillingCredit extends ModelBase {
    public static storeName: string = 'cmsBillingCredit';

    public refund: CmsBillingPaymentSimple;
    public credit: CmsBillingPaymentSimple;
    public reversalCredit: CmsBillingPaymentSimple;
}
